import { makeStyles, useTheme } from '@material-ui/core/styles';

type propsType = {
	backgroundImage: string
};

export const Theme = useTheme;

export const useStyles = makeStyles(theme => ({
	container: {
		backgroundImage: (props: propsType) => `url(${props.backgroundImage})`,
		WebkitTransition: "background-image 0.2s ease-in-out",
		transition: "background-image 0.2s ease-in-out",
		backgroundSize: "cover",
		backgroundPosition: "center",
		maxWidth: "100%",
		minHeight: "100vh",
		display: "flex"
	},
	imaxtreeButton: {
		position: "absolute",
		right: 0,
		bottom: 0,
		color: "#FFF",
		fontSize: 16
	},
	cardWrapperMobile: {
		margin: '10px auto'
	},
	card: {
		position: "absolute",
		display: "flex",
		flexDirection: "column",
		width: 273,
		marginTop: 159,
		marginLeft: 50,
		padding: 30,
		backgroundColor: "#FFF",
		"&:last-child": {
			paddingBottom: 30
		},
		borderRadius: 10
	},
	cardMobile: {
		margin: 0,
		position: 'static'
	},
	galleriesLogo: {
		maxWidth: 270,
		width: '100%',
		marginTop: 15,
		marginBottom: 15
	},
	subtitle: {
		fontSize: 18,
		color: "#EC4C47",
		lineHeight: '20px',
		marginBottom: 20
	}
}));
